import type { ReactiveController, ReactiveControllerHost } from "lit";

export class DragDropController implements ReactiveController {
  host: ReactiveControllerHost;

  onFileDrop: (file: File) => void;
  accept?: string[];
  isDragging: boolean = false;

  constructor(host: ReactiveControllerHost, onFileDrop: (file: File) => void, accept?: string[]) {
    (this.host = host).addController(this);
    this.onFileDrop = onFileDrop;
    this.accept = accept;
  }

  hostConnected(): void {}

  hostDisconnected(): void {}

  /** Handle drop event */
  handleDrop = (event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const file = event.dataTransfer?.files?.[0];
    if (!file) return;

    // Validate file type if `accept` is set
    if (this.accept && !this.accept.some((type) => file.type.startsWith(type))) {
      console.warn("Unsupported file type:", file.type);
      this.host.requestUpdate();
      return;
    }

    this.onFileDrop(file);
  };

  /** Handle dragover */
  handleDragOver = (event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (!this.isDragging) {
      this.isDragging = true;
      this.host.requestUpdate();
    }
  };

  /** Handle dragleave */
  handleDragLeave = (event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.isDragging) {
      this.isDragging = false;
      this.host.requestUpdate();
    }
  };
}
